import { render, staticRenderFns } from "./ModalEditTask.vue?vue&type=template&id=0b53f96b&scoped=true&"
import script from "./ModalEditTask.vue?vue&type=script&lang=js&"
export * from "./ModalEditTask.vue?vue&type=script&lang=js&"
import style0 from "./ModalEditTask.vue?vue&type=style&index=0&id=0b53f96b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b53f96b",
  null
  
)

export default component.exports